import { UserRoleEnum } from '@enums/user-role.enum';
import { ServiceRequestTypeEnum } from '@enums/service-request-type.enum';

export const canShowOrTime = (serviceType: ServiceRequestTypeEnum): boolean => {
  const allowedTypes: ServiceRequestTypeEnum[] = [
    ServiceRequestTypeEnum.ORGAN,
    ServiceRequestTypeEnum.SPECIMEN,
    ServiceRequestTypeEnum.TEAM,
    ServiceRequestTypeEnum.HAND_CARRY,
  ];

  return allowedTypes.some((type) => type === serviceType);
};

export const canGenerateTemplate = (userRole: UserRoleEnum | string): boolean => {
  const allowedRoles: UserRoleEnum[] = [UserRoleEnum.COORDINATOR, UserRoleEnum.MANAGEMENT, UserRoleEnum.EXECUTIVE_ADMIN];

  return allowedRoles.some((item) => item === userRole);
};
